import { render, staticRenderFns } from "./onFileRemove.vue?vue&type=template&id=23b15af4&scoped=true"
import script from "./onFileRemove.vue?vue&type=script&lang=js"
export * from "./onFileRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b15af4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b15af4')) {
      api.createRecord('23b15af4', component.options)
    } else {
      api.reload('23b15af4', component.options)
    }
    module.hot.accept("./onFileRemove.vue?vue&type=template&id=23b15af4&scoped=true", function () {
      api.rerender('23b15af4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/event-handler/onFileRemove.vue"
export default component.exports